module.exports = function getResource(label, vars = []) {
    let resources = {
        search: 'Recherche',
        cancel: 'Annuler',
        previousSearches: 'Recherches précédentes',
        clearInputAriaLabel: 'effacer le texte de la recherche'
    };

    return resources[label];
};
